module.exports = __webpack_public_path__ + "static/media/ic_cell_info.5d871ac2.svg";